<template>
    <div id="toolbar">
        <v-app-bar :height="50" app color="white" clipped-left elevation="0">
            <v-spacer></v-spacer>

            <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                    <div icon v-bind="attrs" v-on="on">
                        <v-avatar size="32">
                            <v-img
                                :src="
                                    require('@/assets/img/avatar-default.svg')
                                "
                            ></v-img>
                        </v-avatar>
                        <v-icon color="#4F4F4F">mdi-menu-down</v-icon>
                    </div>
                </template>

                <v-list>
                    <v-list-item @click="handleLogout">
                        <v-list-item-title class="test_cursor"
                            >Logout</v-list-item-title
                        >
                    </v-list-item>
                </v-list>
            </v-menu>
        </v-app-bar>
    </div>
</template>

<script>
import auth from "@/modules/auth/services/auth.js";
import logo from "@/assets/img/launcher.png";

export default {
    name: "app-header",

    data() {
        return {
            title: "Skolla Admin",
            logo: logo,
        };
    },

    computed: {
        picture() {
            return this.$ls.get("profiles").picture;
        },
    },

    methods: {
        handleLogout() {
            var token = localStorage.getItem("jwtToken");
            var context = this;

            auth.doLogout(token, function (result) {
                if (result.success) {
                    context.$ls.clear();
                    context.$store.commit("auth_destroyed");
                    context.$router.push("/");
                }
            });
        },
    },
};
</script>



// WEBPACK FOOTER //
// TheToolbar.vue?3e34ac33